import { useEffect } from "react";
import "./GEOVsSEO.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import PillarServices from "./sections/PillarServices";
import GeoComparisonSlider from "./sections/GeoComparisonSlider";
import MarketDomination from "./sections/MarketDomination";
import Footer from "@/reusable_sections/Footer";
export default function GEOVsSEOPage() {
  useEffect(() => {
    document.title = "GEO vs SEO | ClearLine GEO";
  }, []);
  return <div>
      <Header />
      <Hero />
      <PillarServices />
      <GeoComparisonSlider />
      <MarketDomination />
      <Footer />
    </div>;
}